/** Decode a waveform without leaving AudioContexts open on a failed fetch. */
export const decodeWaveform = async (url: string, bars: number): Promise<Float32Array> => {
  const context = new AudioContext();
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Audio could not be loaded (${response.status})`);
    const audio = await context.decodeAudioData(await response.arrayBuffer());
    const data = audio.getChannelData(0);
    const blockSize = Math.max(1, Math.floor(data.length / bars));
    const result = new Float32Array(bars);
    for (let i = 0; i < bars; i++) {
      let sum = 0;
      for (let j = 0; j < blockSize; j++) sum += Math.abs(data[i * blockSize + j] ?? 0);
      result[i] = sum / blockSize;
    }
    const max = Math.max(...result);
    if (max > 0) for (let i = 0; i < bars; i++) result[i] = 0.08 + (result[i]! / max) * 0.92;
    return result;
  } finally {
    await context.close();
  }
};
